
import React from 'react'
import { useState } from "react";
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import MenuBar from '../MenuBar';
import GoogleMapLocationMarkers from './mapGoogleLocationMarkers';
import { useSelector } from 'react-redux'


export default function GoogleMapView() {

  const [lat, setLat] = React.useState(51.511057);
  const [lng, setLng] = React.useState(6.960048);
  const [center, setCenter] = React.useState({lat: 51.511057, lng: 6.960048})

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: apiKey
  })

  const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined
    });
    
  const pdfPrintData = useSelector(state => state.showRefState.pdfPrintData)


  React.useEffect(() => {
      // set map center 
      if(localStorage.getItem('language') === 'pt-br') {
        setCenter({lat: -23.546235, lng: -46.634661});
      } else {
        setCenter({lat: 51.511057, lng: 6.960048});
      }

      if(pdfPrintData.length > 0) {
        setLat(Number(pdfPrintData[0].latitude));
        setLng(Number(pdfPrintData[0].longitude));
        setCenter({lat: Number(pdfPrintData[0].latitude), lng: Number(pdfPrintData[0].longitude)});
      }

  }, []);

  React.useEffect(() => {
      function handleResize() {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    }, []);

  return isLoaded ? (
      
      <div>
        <MenuBar/>
      <div style={{ width: '50%', justifyContent: 'center', marginBottom: 10, padding: 0, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}>
      </div>
       <GoogleMap
        mapContainerStyle={windowSize}
        // center={{ lat: 51.511057, lng: 6.960048 }}
        center={center}
        zoom={10}
      > 
      {/* Set markers to map */}
        <GoogleMapLocationMarkers/>

      </GoogleMap>
       </div>
  ) : <div> </div>
} 
